import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, message, DatePicker } from "antd";
import "./Form.css";
import numeral from "numeral";
import moment from "moment-timezone"; // VALIDAR DATAS
import { maskDate } from "../utils/Masker";
import axios from "axios";
import InputForm from "./InputForm";
import PessoaFrame from './PessoaFrame';
import TipoDocFrame from './TipoDocFrame';
import CtaCorrenteFrame from './CtaCorrenteFrame';
import Colors from '../utils/Colors';

const { Item: ItemForm } = Form;

export default class CaixaTransferenciaForm extends Component {
  state = {
    registro: {
      tit_data_emissao: moment().format('DD/MM/YYYY'),
      tit_valor: 0,
      tit_pessoa: { key: '0' },
      tit_descricao: '',
      tit_tipo_doc: { key: '0' },
      tparc_conta_corrente_orig: { key: '0' },
      tparc_conta_corrente_dest: { key: '0' },
    },
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroParc !== propsAnterior.registroParc) {
      this.setState({
        registro: this.props.registroSelecionado,
      }, () => {
        // this.calculaVlrParc();
      });
    }
  }

  onOK = () => {
    // console.log('onOK Registro gravar: ', this.state.registro);

    const dataAtual = moment().format('YYYY-MM-DD');
    const dataEmiss = moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
    if (dataEmiss > dataAtual) {
      Modal.warning({ title: 'Aviso!', content: 'Data de tranferência maior que data atual.' });
      return;
    }

    if ((!this.state.registro.tit_valor) || (this.state.registro.tit_valor === 0) || (this.state.registro.tit_valor === '0')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor' });
      return;
    }

    if (this.state.registro.tit_descricao === '') {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }

    if ((!this.state.registro.tit_pessoa) || (this.state.registro.tit_pessoa.key === '0') || (this.state.registro.tit_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Pessoa' });
      return;
    }

    if ((!this.state.registro.tit_tipo_doc) || (this.state.registro.tit_tipo_doc.key === '0') || (this.state.registro.tit_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento' });
      return;
    }

    if ((!this.state.registro.tparc_conta_corrente_orig) || (this.state.registro.tparc_conta_corrente_orig.key === '0') || (this.state.registro.tparc_conta_corrente_orig.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente Origem' });
      return;
    }

    if ((!this.state.registro.tparc_conta_corrente_dest) || (this.state.registro.tparc_conta_corrente_dest.key === '0') || (this.state.registro.tparc_conta_corrente_dest.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente Destino' });
      return;
    }

    if (this.state.registro.tparc_conta_corrente_orig.key === this.state.registro.tparc_conta_corrente_dest.key) {
      Modal.warning({ title: 'Aviso!', content: 'Conta Corrente de Origem e Destino não podem ser iguais' });
      return;
    }

    this.setState({ salvando: true })

    const registro = {
      tit_data_emissao: moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      tit_descricao: this.state.registro.tit_descricao,
      tit_pessoa: String(this.state.registro.tit_pessoa.key),
      tit_valor: this.state.registro.tit_valor,
      tit_tipo_doc: String(this.state.registro.tit_tipo_doc.key),
      tparc_conta_corrente_orig: this.state.registro.tparc_conta_corrente_orig.key,
      tparc_conta_corrente_dest: this.state.registro.tparc_conta_corrente_dest.key,
    };

    // console.log('onOK Registro gravar: ', registro);
    // return;

    axios.post('/titulos/transferencia', registro)
      .then(response => {
        this.setState({
          formVisivel: false,
          salvando: false,
        })

        this.props.onTransferenciaClick();
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', },
            this.props.onCancelarTransfClick()
          )
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível gravar. ' + error.response.data, okText: 'OK', },
            this.props.onCancelarTransfClick()
          )
        }
      })

  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['tit_pessoa'] = event.tit_pessoa;
    this.setState(event);
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['tit_tipo_doc'] = event.tit_tipo_doc;
    this.setState(event);
  }

  onChangeCtaCorrenteOrig = event => {
    const { registro } = this.state;
    registro['tparc_conta_corrente_orig'] = event.tparc_conta_corrente_orig;
    this.setState(event);
  }

  onChangeCtaCorrenteDest = event => {
    const { registro } = this.state;
    registro['tparc_conta_corrente_dest'] = event.tparc_conta_corrente_dest;
    this.setState(event);
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['tit_data_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ tit_data_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };




  render() {
    const { onCancelarTransfClick, visivel } = this.props;
    const { tit_data_emissao, tit_valor, tit_pessoa, tit_descricao,
      tit_tipo_doc, tparc_conta_corrente_orig, tparc_conta_corrente_dest } = this.state.registro;

    // console.log('CaixaTransferenciaForm.this.state: ', this.state);

    return (
      <Modal
        title={"Transferência entre Contas Correntes"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarTransfClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >


        <Row style={{ marginTop: -20, marginLeft: 10 }}>
          <Col xs={24} sm={6} style={{ marginTop: 3 }} className="camposEspacoDireita">
            <span>Data</span>
            <DatePicker
              onChange={this.onDateChange}
              format="DD/MM/YYYY"
              showToday={true}
              allowClear={false}
              value={moment(tit_data_emissao, "DD/MM/YYYY", true)}
              style={{ width: "100%" }}
            />
          </Col>

          <Col xs={24} sm={6} className="camposEspacoDireita">
            <span>Valor</span>
            <InputForm
              type="number"
              id="tit_valor"
              ref="tit_valor"
              value={tit_valor}
              onChange={this.onChange}
            />
          </Col>
          <Col xs={12} sm={12}>
            <span>Descrição</span>
            <InputForm
              id="tit_descricao"
              ref="tit_descricao"
              value={tit_descricao}
              maxLength={60}
              onChange={this.onChange}
              validator={value => Boolean(value)}
            />
          </Col>
          <Col xs={12} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <PessoaFrame
              label="Pessoa"
              id="tit_pessoa"
              value={tit_pessoa}
              width={"100%"}
              onChange={this.onChangePessoa}
              descricaoPrimeiroItem="Selecione uma Pessoa"
            />
          </Col>
          <Col xs={12} sm={12} style={{ marginTop: -20 }}>
            <TipoDocFrame
              label="Tipo Documento"
              id="tit_tipo_doc"
              value={tit_tipo_doc}
              width={"100%"}
              onChange={this.onChangeTipoDoc}
              descricaoPrimeiroItem="Selecione um Tipo de Documento"
            />
          </Col>
          <Col xs={12} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <CtaCorrenteFrame
              label="Conta Corrente Origem"
              id="tparc_conta_corrente_orig"
              value={tparc_conta_corrente_orig}
              width={"100%"}
              onChange={this.onChangeCtaCorrenteOrig}
              descricaoPrimeiroItem="Selecione uma Conta Corrente"
            />
          </Col>
          <Col xs={12} sm={12} style={{ marginTop: -20 }}>
            <CtaCorrenteFrame
              label="Conta Corrente Destino"
              id="tparc_conta_corrente_dest"
              value={tparc_conta_corrente_dest}
              width={"100%"}
              onChange={this.onChangeCtaCorrenteDest}
              descricaoPrimeiroItem="Selecione uma Conta Corrente"
            />
          </Col>

        </Row>


        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onOK}
                  className="btn-salvar"
                  style={{ width: 130 }}
                >
                  Gravar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarTransfClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CaixaTransferenciaForm.js